import React from "react"
import { Link } from "gatsby"

const HomeIntro = props => {
  return (
    <article className="home-intro">
      <div className="container">
        <div className="home-intro__head fade-in-delay-4">
          <h4>
            I build <strong>websites</strong>.
          </h4>
        </div>
        <div className="home-intro__body fade-in-delay-5">
          <p>
            I've held different positions over the last nineteen years that
            allow me to deliver value by bringing together creativity and
            technology.
          </p>
          <p>
            Having had roles as a front-end developer, graphic designer,
            creative director, and project manager, I have the skills and
            knowledge to help make software development projects successful.
          </p>
          <Link to="/about/" className="home-intro-cta">
            Learn More
          </Link>
        </div>
      </div>
    </article>
  )
}

export default HomeIntro
